<template lang="html">
  <div class="vh-100 overflow-y-scroll">
    <div class="ma2">
      <pl-button @click.native="$router.go(-1)" class="pl-primary">
        Go back
      </pl-button>
    </div>

    <!-- <div class="dank-banner shadow-1" :style="image_source"/> -->

    <!-- Tab selection -->
    <div class="flex justify-around ma2">
      <pl-button
        class="pl-secondary-font pl-border shadow-1"
        :class="
          tab === 'edit_school_info' ? ['pl-secondary', 'pl-white-font'] : []
        "
        @click.native="tab = 'edit_school_info'"
      >
        Edit School Information (codes, basic info)
      </pl-button>
      <pl-button
        class="pl-secondary-font pl-border shadow-1"
        :class="
          tab === 'manage_school_membership'
            ? ['pl-secondary', 'pl-white-font']
            : []
        "
        @click.native="tab = 'manage_school_membership'"
      >
        Edit School Memberships (payments, Memberships)
      </pl-button>
      <pl-button
        class="pl-secondary-font pl-border shadow-1"
        :class="
          tab === 'manage_teachers_in_school'
            ? ['pl-secondary', 'pl-white-font']
            : []
        "
        @click.native="tab = 'manage_teachers_in_school'"
      >
        Manage Teachers in School
      </pl-button>
      <pl-button
        class="pl-secondary-font pl-border shadow-1"
        :class="
          tab === 'school_engagement_summary'
            ? ['pl-secondary', 'pl-white-font']
            : []
        "
        @click.native="tab = 'school_engagement_summary'"
      >
        See School Usage Summary
      </pl-button>
    </div>

    <!-- School management and school information tabs -->
    <edit-school-info
      class="ma4 mw8 center"
      v-if="tab === 'edit_school_info'"
      :schoolTitle="true"
    />
    <manage-school-membership
      class="ma4 mw8 center"
      v-if="tab === 'manage_school_membership'"
    />
    <manage-teachers-in-school
      class="ma4 mw8 center"
      v-if="tab === 'manage_teachers_in_school'"
    />
    <school-engagement-summary
      class="ma4 mw9 center"
      v-if="tab === 'school_engagement_summary'"
    />
  </div>
</template>

<script>
  // import adminServices from 'services/admin/adminServices';

  // Tabs
  import editSchoolInfo from './individualSchoolTabs/editSchoolInfo.vue';
  import manageSchoolMembership from './individualSchoolTabs/manageSchoolMembership.vue';
  import manageTeachersInSchool from './individualSchoolTabs/manageTeachersInSchool.vue';
  import schoolEngagementSummary from './individualSchoolTabs/schoolEngagementSummary.vue';

  export default {
    data() {
      return {
        tab: 'edit_school_info',
        image_to_display: '',
        dank_images: [
          'https://amp.businessinsider.com/images/594bdcc2a3630ff71a8b46bf-1334-667.jpg', // Cheese
          'https://s2.glbimg.com/Ycq7fLlc_eI1ztpGW8P9qY9mmxU=/300x200/i.glbimg.com/og/ig/infoglobo1/f/original/2017/11/27/pastel_2.jpg', // Madame Pastel
          'https://d1qb2nb5cznatu.cloudfront.net/users/3432473-large?1472513465', // Bobby
          'https://www.ischgl.com/website/var/tmp/image-thumbnails/20000/29030/thumb__lightbox/nickelback-website2.jpeg', //nickelback
          'https://i.kym-cdn.com/entries/icons/original/000/023/081/tumblr_obk6qohUcA1vpv8z8o1_500.png', // Papa Bless
          'https://res.cloudinary.com/teepublic/image/private/s--1oQ7H4w4--/t_Preview/b_rgb:191919,c_limit,f_jpg,h_630,q_90,w_630/v1478426587/production/designs/776204_1.jpg', // dab dragonball
          // 'https://media.tenor.com/images/d6083c84fa410d47badd2aa107ff3a60/tenor.png', // Hang Loose guy
          // 'https://scontent-yyz1-1.xx.fbcdn.net/v/t1.0-9/36324094_1937597736258541_3425885302219079680_o.jpg?_nc_cat=0&oh=143fbbdd715782b5c4da1aa087d788f9&oe=5BC91D67', // Vielson
          // 'https://i.imgflip.com/2ficdb.jpg', // Government meme
        ],
      };
    },
    components: {
      manageTeachersInSchool,
      editSchoolInfo,
      manageSchoolMembership,
      schoolEngagementSummary,
    },
    computed: {
      image_source() {
        return {
          'background-image': `url(${this.image_to_display})`,
        };
      },
    },
    mounted() {
      this.randomizeImageSource();
    },
    methods: {
      randomizeImageSource() {
        this.image_to_display = this.dank_images[
          Math.floor(Math.random() * this.dank_images.length)
        ];
      },
    },
  };
</script>

<style scoped lang="stylus">
  .dank-banner
    height: 200px
    background-repeat: repeat
    background-size: contain
</style>



// WEBPACK FOOTER //
// viewIndividualSchool.vue?3fc72b6d